import ThirdParty from 'supertokens-auth-react/recipe/thirdparty';
import Passwordless from 'supertokens-auth-react/recipe/passwordless';
import Session from 'supertokens-auth-react/recipe/session';

export function getApiDomain() {
  return `${import.meta.env.VITE_API_BASE_ENDPOINT}`;
}

export function getWebsiteDomain() {
  return `${import.meta.env.VITE_APP_BASE_ENDPOINT}`;
}

export const SuperTokensConfig = {
  appInfo: {
    appName: 'Taskonio',
    apiDomain: getApiDomain(),
    websiteDomain: getWebsiteDomain(),
    apiBasePath: '/auth',
    websiteBasePath: '/signup',
  },
  getRedirectionURL: async (context) => {
    if (context.action === 'SUCCESS' && context.newSessionCreated) {
      // called on a successful sign in / up. Where should the user go next?
      const redirectToPath = context.redirectToPath;
      if (redirectToPath !== undefined) {
        // we are navigating back to where the user was before they authenticated
        return redirectToPath;
      }
      if (context.createdNewUser) {
        // user signed up
        return '/';
      } else {
        // user signed in
        return '/';
      }
    }
    // return undefined to let the default behaviour play out
    return undefined;
  },
  recipeList: [
    ThirdParty.init({
      signInAndUpFeature: {
        providers: [
          ThirdParty.Github.init(),
          ThirdParty.Google.init(),
          ThirdParty.Apple.init(),
          ThirdParty.Twitter.init(),
        ],
      },
    }),
    Passwordless.init({
      contactMethod: 'EMAIL',
    }),
    Session.init(),
  ],
};
